/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { funcMeta } from './funcMeta';
import classes from './FormulaBuilder.module.css';

const Operators = (props) => {

    const operators = funcMeta.functionTypes[0].functions;

    const operatorClicked = (item) => {
        props.operatorClicked(item);
    };

    return (
        <div className={classes.Operators}>
            <div className={classes.FunctionHead}>Functions</div>
            <ul>
                {operators.map((item,index) => (
                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                    <button  key={index} onClick={() => operatorClicked(item)}>{item.name}</button>
                ))}
            </ul>

        </div>
    );
};

export default Operators;
